var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3346 17.8346V15.168H9.33464V11.168L2.66797 16.5013L9.33464 21.8346V17.8346H21.3346Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 4.5H14.6667C13.196 4.5 12 5.696 12 7.16667V12.5H14.6667V7.16667H26.6667V25.8333H14.6667V20.5H12V25.8333C12 27.304 13.196 28.5 14.6667 28.5H26.6667C28.1373 28.5 29.3333 27.304 29.3333 25.8333V7.16667C29.3333 5.696 28.1373 4.5 26.6667 4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e70fd9783377544d0a17e929a736af7f.svg";
export { ForwardRef as ReactComponent };